<template>
    <div class="prp-table-container">
        <h5>Resultados de Votos en:</h5>
        <h1>{{data.division.desc_ures_pred}} - {{data.division.ures_pred}} </h1>

        <h1>Ganador: <i class="fas fa-trophy"></i> {{data.winner.name}} Votos: {{data.winner.total}}</h1>

        <small>
            *esta informacion puede cambiar hacia el final de la eleccion
        </small><br />
        <v-row>

            <v-col
                cols='12'
                md='4'
            >
                Grafica de Votacion
                <apexchart class="chart-pie" type="donut" width="100%" :options="chartOptionsvotes" :series="seriesvotes"></apexchart>

            </v-col>
            <v-col
                cols='12'
                md='4'
            >
                Participantes:
                <v-data-table
                    :headers="headers"
                    :items="data.votos"
                    class="elevation-1"
                ></v-data-table>
            </v-col>
            <v-col
                cols='12'
                md='4'
            >
                Participación
                <v-simple-table>
                    <template v-slot:default>
                        <thead>
                        <tr>
                            <th class="text-center">
                                Electores
                            </th>
                            <th class="text-center">
                                Abstenciones
                            </th>
                            <th class="text-center">
                                Padron de Eleccion
                            </th>
                            <th>
                                Porcentaje de Votos
                            </th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr>
                            <td>{{ data.participacion.totalparticipacion }}</td>
                            <td>{{ data.participacion.padron - data.participacion.totalparticipacion }}</td>
                            <td>{{ data.participacion.padron }}</td>
                            <td>{{ data.participacion.porcentajeparticipacion }}%</td>
                        </tr>
                        </tbody>
                    </template>
                </v-simple-table>

                <apexchart class="chart-pie" type="pie" width="70%" :options="chartOptionsparticipacion" :series="seriesparticipacion"></apexchart>
                <v-simple-table>
                    <template v-slot:default>
                        <thead>
                        <tr>
                            <th class="text-center">
                                Votos Ejercidos
                            </th>
                            <th class="text-center">
                                Votos No Ejercidos
                            </th>

                        </tr>
                        </thead>
                        <tbody>
                        <tr>
                            <td>{{ data.participacion.totalparticipacion }}</td>
                            <td>{{ data.participacion.padron - data.participacion.totalparticipacion }}</td>
                        </tr>
                        </tbody>
                    </template>
                </v-simple-table>
            </v-col>
        </v-row>
    </div></template>

<script>

import ScaleLoader from 'vue-spinner/src/ScaleLoader';
import VueApexCharts from 'vue-apexcharts';

export default {
    props: ['data','colores','hexa_colors'],
    components: {
        ScaleLoader,
        apexchart: VueApexCharts,
    },

    data: () => ({
        loading:false,
        seriesparticipacion : [],
        seriesvotes:[],
        headers: [
            {
                text: 'Planilla Participante',
                align: 'start',
                sortable: false,
                value: 'name',
            },
            { text: 'Votos Ejercidos', value: 'total' },
        ],
        chartOptionsvotes: {
            chart: {
                width: 380,
                type: 'bar',
            },

            //colors : ['#2E93fA','#90BBD8'],
            //labels : ['Votantes','Faltantes'],
            responsive: [{
                breakpoint: 480,
                options: {
                    chart: {
                        width: 200
                    },
                    legend: {
                        position: 'bottom'
                    }
                }
            }]
        },
        chartOptionsparticipacion: {
            chart: {
                width: 380,
                type: 'pie',
            },
            //colors : ['#2E93fA','#90BBD8'],
            //labels : ['Votantes','Faltantes'],
            responsive: [{
                breakpoint: 480,
                options: {
                    chart: {
                        width: 200
                    },
                    legend: {
                        position: 'bottom'
                    }
                }
            }]
        },
    }),
    methods: {
        loadOptions: function() {
            let colors1 = ['#2E93fA','#6DB3FB','#ADD4FD','#79BABF','#86C0FC','#66D8F8' ];
            let colors2 = ['#90BBD8','#E0EDFf5','#4D8EBA','#F2F7FB','#377EAF','#D8EEF2'];
            let color1 = colors1[Math.floor(Math.random() * colors1.length)];
            let color2 =  colors2[Math.floor(Math.random() * colors2.length)];

            let labels = [];
            let values = [];
            let votos  = this.data.votos;
            votos.forEach(e =>{
                labels.push(e.name);
                values.push(e.total);
            });
            this.chartOptionsvotes.labels = labels;
            this.seriesvotes = values;
            this.chartOptionsvotes.colors = this.hexa_colors;
            this.chartOptionsparticipacion.colors = ['#2E93fA','#90BBD8'];
            this.chartOptionsparticipacion.labels = ['Votantes','Faltantes'];
            let faltan = this.data.participacion.padron  - this.data.participacion.totalparticipacion;
            this.seriesparticipacion = [this.data.participacion.totalparticipacion,faltan];
        },
    },

    created() {
        this.loadOptions();
    },

}

</script>
